export default __webpack_public_path__ + "static/gameScreen-7b98a9764d64e1934e9febab3e2586f4.png";